import { IAccQuyDoiTyGiaActionTypes } from "../../action-types/category/IAccQuyDoiTyGiaActions";
import { IQuyDoiTyGiaReducer } from "../../reducer-model/category/IQuyDoiTyGiaReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IQuyDoiTyGiaReducer = {
  status: eReducerStatusBase.is_not_initialization,
  quyDoiTyGias: [],
};
export const quyDoiTyGiaReducer = (
  state: IQuyDoiTyGiaReducer = iniState,
  action: IAccQuyDoiTyGiaActionTypes,
): IQuyDoiTyGiaReducer => {
  switch (action.type) {
    case "QUY_DOI_TY_GIA_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "QUY_DOI_TY_GIA_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        quyDoiTyGias: action.payload,
      };
    case "QUY_DOI_TY_GIA_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUY_DOI_TY_GIA_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "QUY_DOI_TY_GIA_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "QUY_DOI_TY_GIA_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUY_DOI_TY_GIA_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "QUY_DOI_TY_GIA_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "QUY_DOI_TY_GIA_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUY_DOI_TY_GIA_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        quyDoiTyGiaEditing: action.payload,
      };
    case "QUY_DOI_TY_GIA_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        quyDoiTyGiaEditing: undefined,
      };
    default:
      return state;
  }
};
